//import SelectDateController from "../ReuseComps/SelectDateController";
import DateController from "../ReuseComps/DateController";

export default function SelectDateArterio() {

  return (

   <DateController
    category = "arteriosclerosis_prevention"  
   />

  );
}
